import styled from 'styled-components';
import { primary, neutral } from '../../../../style/colors';

const slideIn = `
  @keyframes slideIn {
    from { opacity: 0; transform: translateX(-10px); }
    to { opacity: 1; transform: translateX(0); }
  }
`;

export const Section = styled.div`
  padding: 0;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${neutral[900]};
  margin-bottom: 24px;
  letter-spacing: -0.3px;
`;

export const HighlightsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-top: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const HighlightsColumn = styled.div``;

export const HighlightsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HighlightItem = styled.li`
  ${slideIn}
  padding-left: 32px;
  position: relative;
  animation: slideIn 0.3s ease backwards;
  animation-delay: ${props => props.index * 0.05}s;

  i {
    position: absolute;
    left: 0;
    top: 4px;
    color: ${primary[500]};
    font-size: 20px;
  }
`;

export const HighlightTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${primary[500]};
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const HighlightSubtitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${neutral[700]};
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const HighlightBody = styled.div`
  font-size: 14px;
  line-height: 1.7;
  color: ${neutral[600]};
`;
